import flavorValues from '@/helpers/app-flavor';

export default {
  install: (app) => {
    app.config.globalProperties.$flavor = Object.assign({}, flavorValues);
  },
};
